import React from 'react'
import { Typography, Chip } from '@the-platform-group/component-library'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import { DATE } from '@the-platform-group/component-library/DataGrid/constant'
import { FDS_STATUS_COLORS } from 'constants/fdsAdmin'

const COLUMNS = [
  {
    field: 'usernameSerial',
    headerName: 'Factset Username Serial Number',
    width: 200,
  },
  {
    field: 'status',
    width: 120,
    renderCell: ({ value }) => (
      <Chip
        label={value}
        size="small"
        color={FDS_STATUS_COLORS[value] || FDS_STATUS_COLORS.default}
      />
    ),
  },
  {
    field: 'expiredAt',
    headerName: 'Expired At',
    width: 150,
    type: DATE,
  },
]

const UserFdsadminDetails = ({ details }) => {
  const rows = (details || []).map((d, i) => ({ id: d.usernameSerial || i, ...d }))

  return (
    <>
      <Typography variant="h5" component="h2">
        FDS Admin Details
      </Typography>
      <DataGrid
        name="UserFdsadminDetailsTable"
        columns={COLUMNS}
        commonColumnProps={{ headerAlign: 'left' }}
        rows={rows}
        rowCount={rows.length}
        localeText={{
          noRowsLabel: 'No FDS admin details found for this user.',
        }}
        sx={{
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
          },
        }}
        autoHeight
      />
    </>
  )
}

export default UserFdsadminDetails
